var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCrossLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5835 12.0018L5.29688 6.71496L6.71113 5.30078L11.9976 10.5876L17.2842 5.30078L18.6984 6.71496L13.4118 12.0018L18.6984 17.2887L17.2842 18.7029L11.9976 13.4161L6.71113 18.7029L5.29688 17.2887L10.5835 12.0018Z",
    fill: "#fe5f00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCrossLink);
export default __webpack_public_path__ + "static/media/ico_cross_link.395e5e8b1f0866ff55b7f34991818647.svg";
export { ForwardRef as ReactComponent };